const Error404 = () => {
  return <div>404</div>;
};
export default Error404;
